import Modal from 'common/modal';

import EstateStepper from './estate-modal/estate-stepper';

type Props = {
  onExitClick: () => void;
  estateId: string;
  onOrderSearchButtonClick?: () => void;
};

const EditEstateModal = ({ onExitClick, estateId, onOrderSearchButtonClick }: Props) => {
  return (
    <Modal
      setShowModal={onExitClick}
      onExitClick={onExitClick}
      showModal={true}
      showActions={false}
      content={
        <EstateStepper
          onExitClick={onExitClick}
          estateId={estateId}
          onOrderSearchButtonClick={onOrderSearchButtonClick}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="md"
    />
  );
};

export default EditEstateModal;
